import { ConorbitLoader } from "@/components/ui/ConorbitLoader";

export function FullScreenLoader() {
  return <ConorbitLoader variant="fullscreen" />;
}
